import { UIOverlay } from './components/ui/UIOverlay';
import { Scene } from './components/canvas/Scene';
import { StartScreen } from './components/ui/StartScreen';
import { LoadingScreen } from './components/ui/LoadingScreen';
import { MaintenancePage } from './components/ui/MaintenancePage';
import { useStore } from './store/useStore';

function App() {
  const gameStarted = useStore(s => s.gameStarted);
  const maintenanceMode = useStore(s => s.maintenanceMode);

  if (maintenanceMode) return <MaintenancePage />;

  return (
    <>
      <Scene />
      <UIOverlay />
      <LoadingScreen />
      {!gameStarted && <StartScreen />}
    </>
  );
}

export default App;
